module.exports = __webpack_public_path__ + "img/tone.1d1c9bee.png";